if (!customElements.get('read-more-toggle')) {
  customElements.define(
    'read-more-toggle',
    class ReadMoreToggle extends HTMLElement {
      constructor() {
        super();
        this.content = this.querySelector('.rich-text__text--collapsible');
        this.button = this.querySelector('.rich-text__read-more-button');
        if (!this.content || !this.button) return;

        this.labelMore = this.button.dataset.labelMore;
        this.labelLess = this.button.dataset.labelLess;
        this.labelEl = this.button.querySelector('.rich-text__read-more-label');

        // Visa bara knappen om texten faktiskt är högre än den kollapsade höjden.
        this.init();
      }

      init() {
        // Vid SDR/temaredigering kan layout dröja; mät efter att DOM stabiliserats.
        requestAnimationFrame(() => {
          if (this.content.scrollHeight <= this.content.clientHeight + 1) {
            this.button.classList.add('hidden');
            this.content.classList.remove('rich-text__text--collapsible');
            return;
          }
          this.button.addEventListener('click', () => this.toggle());
        });
      }

      toggle() {
        const expanded = this.content.classList.toggle('is-expanded');
        this.button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (this.labelEl) {
          this.labelEl.textContent = expanded ? this.labelLess : this.labelMore;
        }
      }
    }
  );
}
